import { Button, Col, Row } from "react-bootstrap";
import { compose, pure, withHandlers, withState } from "recompose";

import { components } from "react-select";
import CreatableSelect from "react-select/lib/Creatable";
import { FormattedMessage } from "react-intl";
import Queries from "../../queries/queries2";
import React from "react";
import TierCreateSideModal from "./TierCreateSideModal";
import TierUpdateSideModal from "./TierUpdateSideModal";
import _ from "lodash";
import clientCreationHandlers from "../../containers/Contacts/ClientsContainerHandlers";
import collaboratorCreationHandlers from "../../containers/Contacts/CollaboratorsContainerHandlers";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";
import supplierCreationHandlers from "../../containers/Contacts/SuppliersContainerHandlers";
import { withLoadingWait } from "../../hoc/withLoadingSpinner";

// import {
//   withLoadingSpinner,
//   withLoadingWait
// } from "../../hoc/withLoadingSpinner";

// import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";

// DOC here: https://github.com/apollographql/apollo-client/blob/master/docs/source/basics/queries.md

const data = graphql(Queries.getTierses, {
  // name: "getTierses",

  // options: (showCollaborators) => {
  //   fetchPolicy: "network-only",
  //   { variables: {
  //     { showCollaborators }
  //   }
  // },
  props: ({
    ownProps,
    // data,
    data,
    data: { refetch },
    showSuppliers,
    showClients,
    showCollaborators,
    showComptables
  }) => {
    // console.log("data", data);
    // console.log("ownprops", ownProps);
    return {
      refetch,
      data,
      showSuppliers,
      showClients,
      showCollaborators,
      showComptables,
      nullValue: null
    };
  }
});

const createSideModalVisible = withState(
  "createSideModalVisible",
  "setCreateSideModalVisible",
  false
);

const updateSideModalVisible = withState(
  "updateSideModalVisible",
  "setUpdateSideModalVisible",
  false
);

const inputName = withState("inputName", "setInputName", "");

const selectedTiersType = withState(
  "selectedTiersType",
  "setSelectedTiersType",
  ({ data, value }) => {
    if (value) {
      if (data && _.some(data.suppliers, { id: value })) {
        return "supplier";
      }
      if (data && _.some(data.clients, { id: value })) {
        return "client";
      }
      if (data && _.some(data.collaborators, { id: value })) {
        return "collaborator";
      }
    } else {
      return "";
    }
  }
);

const selectionHandler = withHandlers({
  selectHandler: ({ setSelectedTiersType, onSelected }) => value => {
    console.log("selectHandler", value);
    if (!value) {
      onSelected(value);
      return setSelectedTiersType("");
    }
    value.label = value.tiers.name;
    const type = value.tiers.client
      ? "client"
      : value.tiers.collaborator
        ? "collaborator"
        : "supplier";
    setSelectedTiersType(type);
    onSelected(value);
  }
});

const handlers = withHandlers({
  createTiersHandler: ({
    companyId,
    createSupplier,
    createCollaborator,
    createClient,
    setCreateSideModalVisible,
    selectHandler,
    data
  }) => async (tiersType, values) => {
    const createFn =
      tiersType === "collaborator"
        ? createCollaborator
        : tiersType === "client"
          ? createClient
          : createSupplier;
    const mutation = await createFn(values);
    if (mutation) {
      if (data) await data.refetch();
      const newTiers = mutation.data.createTiers;
      console.log("newTiers", newTiers);
      selectHandler({
        value: newTiers.id,
        tiers: newTiers,
        label: newTiers.name
      });
      setCreateSideModalVisible(false);
    }
  },
  updateTiersHandler: ({
    updateSupplier,
    updateCollaborator,
    updateClient,
    setUpdateSideModalVisible,
    value,
    selectHandler,
    data
  }) => async (tiersType, values) => {
    const updateFn =
      tiersType === "collaborator"
        ? updateCollaborator
        : tiersType === "client"
          ? updateClient
          : updateSupplier;
    const mutation = await updateFn(values);
    if (mutation) {
      await data.refetch();
      const newTiers = mutation.data.updateTiers;
      console.log("newTiers", newTiers);
      selectHandler({ value: newTiers.id, tiers: newTiers });
      setUpdateSideModalVisible(false);
    }
  },
  onChange: ({ selectHandler }) => (inputValue, { action }) => {
    // console.log("onChange", inputValue, action);

    switch (action) {
      case "select-option":
      case "clear":
        // selectHandler(inputValue);
        setTimeout(selectHandler, 250, inputValue);
        break;

      default:
        return;
    }
  }
});

let TierSelect = ({
  value,
  companyDefaultInfos,
  data,
  selectHandler,
  disabled,
  isClearable,
  createSideModalVisible,
  setCreateSideModalVisible,
  updateSideModalVisible,
  setUpdateSideModalVisible,
  setInputName,
  inputName,
  createTiersHandler,
  updateTiersHandler,
  selectedTiersType,
  sendNotification,
  onChange,
  error,
  intl,
  showEdit
}) => {
  console.log("TierSelect.render", data);

  const { showSuppliers, showCollaborators, showClients } = data.variables;

  const createOptionGroup = (name, value) => {
    if (value) {
      return {
        label: name,
        options: value.map(tiers => {
          return { label: tiers.name, value: tiers.id, tiers };
        })
      };
    }
  };

  let options = [];

  // console.log("data", getTierses);
  const suppliers = data.suppliers;
  const collaborators = data.collaborators;
  const clients = data.clients;
  // console.log("client", clients, showClients);
  const comptables = data.comptables;

  if (data.variables.showSuppliers && suppliers && suppliers.length > 0) {
    const supplierText = intl.formatMessage({ id: "ids_suppliers" });
    const set = createOptionGroup(supplierText, suppliers);
    options.push(set);
    if (typeof value === "string") {
      const t = _.find(set.options, { value: value });
      if (t) value = t;
    }
  }

  if (
    data.variables.showCollaborators &&
    collaborators &&
    collaborators.length > 0
  ) {
    const collabText = intl.formatMessage({ id: "ids_collaborators" });
    const set = createOptionGroup(collabText, collaborators);
    options.push(set);
    if (typeof value === "string") {
      const t = _.find(set.options, { value: value });
      if (t) value = t;
    }
  }

  if (data.variables.showComptables && comptables && comptables.length > 0) {
    const set = createOptionGroup(
      intl.formatMessage({ id: "ids_accountant" }),
      comptables
    );
    options.push(set);
    if (typeof value === "string") {
      const t = _.find(set.options, { value: value });
      if (t) value = t;
    }
  }

  if (data.variables.showClients && clients && clients.length > 0) {
    const set = createOptionGroup(
      intl.formatMessage({ id: "ids_clients" }),
      clients
    );
    options.push(set);
    if (typeof value === "string") {
      const t = _.find(set.options, { value: value });
      if (t) value = t;
    }
  }

  const borderColor = "hsl(0,0%,80%)";

  const customStyles = {
    // option: (base, state) => ({
    //   ...base
    // }),
    control: () => ({
      // none of react-selects styles are passed to <View />
      //width: 200,
      borderColor: error ? `#b94a48 ${borderColor}` : `#aaa ${borderColor}`,
      border: error ? "1px solid red" : "",
      alignItems: "center",
      // backgroundColor: "hsl(0,0%,98%)",
      borderRadius: "4px",
      borderStyle: "solid",
      borderWidth: "1px",
      cursor: "default",
      display: "flex",
      // display: "-webkit-box -webkit-flex -ms-flexbox flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      minHeight: "38px",
      outline: "0 !important",
      position: "relative",
      transition: "all 100ms",
      boxSizing: "border-box"
    })
    // singleValue: (base, state) => {
    //   // const border = "1px solid green";
    //   // const opacity = state.isDisabled ? 0.5 : 1;
    //   // const transition = 'opacity 300ms';

    //   // return { ...base, border, opacity, transition };
    // }
  };

  const SelectContainer = props => {
    const value = props.getValue();
    return (
      <div title={value[0] && value[0].label || ""}>
        <components.SelectContainer {...props} />
      </div>
    );
  };

  const xsValue = (value && showEdit !== false);

  //https://forum.alsacreations.com/topic-27-78100-1-Display-inline-block--inline-flex-et-width-en-.html
  return (
    <Row>
      <Col
        xs={12}
      // style={{
      //   // padding: "0",
      //   borderColor: error ? "#b94a48" : "#aaa",
      //   border: error ? "1px solid red" : ""
      // }}
      >
        <CreatableSelect
          // className="Select-control"
          id="tiersSelect"          
          defaultOptions
          disabled={disabled}
          name="tiers"
          value={value || null}
          onChange={(value, actions) => {
            console.log("...onchange");
            onChange(value, actions);
          }}
          isValidNewOption={(inputValue, selectValue, selectOptions) => {
            if (inputValue.trim().length === 0) return false;
            const optGroupsLookup = selectOptions.map(options => {
              return options.options.find(
                option => option.label === inputValue
              );
            });
            const c = _.compact(optGroupsLookup);
            return c.length === 0;
          }}
          onCreateOption={inputValue => {
            setInputName(inputValue);
            setCreateSideModalVisible(true);
          }}
          styles={customStyles}
          options={options}
          isClearable={isClearable}
          components={{ SelectContainer }}
        />
      </Col>
      {/* {value && showEdit !== false ? (
        <Col xs={3}>
          <Button
            onClick={() => setUpdateSideModalVisible(true)}
            disabled={disabled}
            bsStyle="primary"
            // round
            style={{
              minWidth: "inherit",
              border: "none",
              padding: "0"
            }}>
            <i className="fa fa-pencil" />
          </Button>
        </Col>
      ) : (
          <div />
        )} */}
      {createSideModalVisible ? (
        <FormattedMessage id="ids_registerNew">
          {title => (
            <TierCreateSideModal
              title={title}
              sendNotification={sendNotification}
              inputName={inputName}
              showSuppliers={showSuppliers}
              showCollaborators={showCollaborators}
              showClients={showClients}
              companyDefaultInfos={companyDefaultInfos}
              onSubmit={createTiersHandler}
              createSideModalVisible={true}
              setCreateSideModalVisible={setCreateSideModalVisible}
            />
          )}
        </FormattedMessage>
      ) : (
        <div />
      )}
      {updateSideModalVisible ? (
        <FormattedMessage id="ids_editThat">
          {title => (
            <TierUpdateSideModal
              tiersType={selectedTiersType}
              sendNotification={sendNotification}
              title={title}
              tiersId={value.value}
              companyDefaultInfos={companyDefaultInfos}
              options={options}
              onSubmit={updateTiersHandler}
              updateSideModalVisible={true}
              setUpdateSideModalVisible={setUpdateSideModalVisible}
            />
          )}
        </FormattedMessage>
      ) : (
        <div />
      )}
    </Row>
  );
};

TierSelect = compose(
  supplierCreationHandlers,
  clientCreationHandlers,
  collaboratorCreationHandlers,
  createSideModalVisible,
  updateSideModalVisible,
  inputName,
  data, // defines getTierses
  withLoadingWait,
  selectedTiersType, // uses _tiersesMetaTierses
  selectionHandler, // uses selectedTiersType
  handlers, // uses getTierses
  pure
)(TierSelect);

export default injectIntl(TierSelect);
